var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"learn-map"},[_c('TopIntro',{attrs:{"data-source":_vm.dataSource}}),_vm._v(" "),_c('Process',{attrs:{"data-source":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }